<div class="w-64 h-screen bg-white flex flex-col shrink-0">
  <!-- Logo e Título -->
  <div class="px-6 py-4 flex items-center space-x-2 shrink-0">
    <div class="w-8 h-8 bg-orange-500 rounded flex items-center justify-center text-white font-bold">
      <i class="pi pi-box text-sm"></i>
    </div>
    <span class="font-semibold text-lg text-gray-800">Sistema</span>
  </div>

  <!-- Menu (rolagem apenas aqui quando o conteúdo passar da tela) -->
  <nav class="flex-1 min-h-0 overflow-y-auto px-2 py-4">
    <a
      (click)="goTo('/app/dashboard')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg mb-2"
      [ngClass]="{
        'bg-orange-500 text-white': isActive('/app/dashboard', true),
        'text-gray-700 hover:bg-gray-100': !isActive('/app/dashboard', true)
      }"
    >
      <i class="pi pi-th-large mr-3"></i>
      Dashboard
    </a>

    <!-- Menu de produtos com Submenu -->
    <div *ngIf="hasModule('estoque')">
      <a
        (click)="toggleProductsMenu()"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg mb-2"
        [ngClass]="{
          'bg-orange-500 text-white': isProductActive(),
          'text-gray-700 hover:bg-gray-100': !isProductActive()
        }"
      >
        <i class="pi pi-box mr-3"></i>
        Estoque
        <i class="pi" [ngClass]="{'pi-chevron-down': !productMenuOpen, 'pi-chevron-up': productMenuOpen}" style="margin-left:auto"></i>
      </a>

      <div *ngIf="productMenuOpen" class="ml-8 flex flex-col">
        <a
          (click)="goTo('/app/products')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/products', true),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/products', true)
          }"
        >
          Produtos
        </a>

        <a
          (click)="goTo('/app/measure-of-unities')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/measure-of-unities'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/measure-of-unities')
          }"
        >
          Unidades de Medidas
        </a>

        <a
          (click)="goTo('/app/brands')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/brands'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/brands')
          }"
        >
          Marcas
        </a>

        <a
          (click)="goTo('/app/groups')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/groups'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/groups')
          }"
        >
          Grupos
        </a>

        <a
          (click)="goTo('/app/sectors')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/sectors'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/sectors')
          }"
        >
          Setores
        </a>

        <a
          (click)="goTo('/app/subgroups')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/subgroups'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/subgroups')
          }"
        >
          Subgrupos
        </a>

        <a
          (click)="goTo('/app/promotions')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/promotions'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/promotions')
          }"
        >
          Promoções
        </a>

        <a
          (click)="goTo('/app/families')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/families'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/families')
          }"
        >
          Famílias
        </a>
      </div>
    </div>

    <!-- Menu de Serviços -->
    <div *ngIf="hasModule('servicos')">
      <a
        (click)="toggleServicesMenu()"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg mb-2"
        [ngClass]="{
          'bg-orange-500 text-white': isServicesActive(),
          'text-gray-700 hover:bg-gray-100': !isServicesActive()
        }"
      >
        <i class="pi pi-briefcase mr-3"></i>
        Serviços
        <i class="pi" [ngClass]="{'pi-chevron-down': !servicesMenuOpen, 'pi-chevron-up': servicesMenuOpen}" style="margin-left:auto"></i>
      </a>

      <div *ngIf="servicesMenuOpen" class="ml-8 flex flex-col">
        <a
          (click)="goTo('/app/services')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/services'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/services')
          }"
        >
          Cadastro de Serviços
        </a>
        <a
          (click)="goTo('/app/service-orders')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/service-orders'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/service-orders')
          }"
        >
          Ordens de Serviço
        </a>
        <a
          (click)="goTo('/app/service-order-templates')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/service-order-templates'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/service-order-templates')
          }"
        >
          Templates
        </a>
      </div>
    </div>

    <!-- Menu de Clientes com Submenu -->
    <div *ngIf="hasModule('clientes')">
      <a
        (click)="toggleCustomersMenu()"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg mb-2"
        [ngClass]="{
          'bg-orange-500 text-white': isCustomerActive(),
          'text-gray-700 hover:bg-gray-100': !isCustomerActive()
        }"
      >
        <i class="pi pi-users mr-3"></i>
        Clientes
        <i class="pi" [ngClass]="{'pi-chevron-down': !customerMenuOpen, 'pi-chevron-up': customerMenuOpen}" style="margin-left:auto"></i>
      </a>

      <div *ngIf="customerMenuOpen" class="ml-8 flex flex-col">
        <a
          (click)="goTo('/app/customers')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/customers') && !isActive('/app/customers/pending-approval'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/customers') || isActive('/app/customers/pending-approval')
          }"
        >
          Clientes
        </a>
        <a
          (click)="goTo('/app/customers/pending-approval')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/customers/pending-approval'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/customers/pending-approval')
          }"
        >
          Pendentes de Aprovação
        </a>
      </div>
    </div>

    <a *ngIf="hasModule('funcionarios')"
      (click)="goTo('/app/employees')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg mb-2"
      [ngClass]="{
        'bg-orange-500 text-white': isActive('/app/employees'),
        'text-gray-700 hover:bg-gray-100': !isActive('/app/employees')
      }"
    >
      <i class="pi pi-users mr-3"></i>
      Funcionários
    </a>

    <a *ngIf="hasModule('fornecedores')"
      (click)="goTo('/app/suppliers')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg mb-2"
      [ngClass]="{
        'bg-orange-500 text-white': isActive('/app/suppliers'),
        'text-gray-700 hover:bg-gray-100': !isActive('/app/suppliers')
      }"
    >
      <i class="pi pi-truck mr-3"></i>
      Fornecedores
    </a>

    <a *ngIf="hasModule('entradas')"
      (click)="goTo('/app/material-entries')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg mb-2"
      [ngClass]="{
        'bg-orange-500 text-white': isActive('/app/material-entries'),
        'text-gray-700 hover:bg-gray-100': !isActive('/app/material-entries')
      }"
    >
      <i class="pi pi-inbox mr-3"></i>
      Entradas
    </a>

    <!-- Menu de Vendas com Submenu -->
    <div *ngIf="hasModule('saidas')">
      <a
        (click)="toggleSalesMenu()"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg mb-2"
        [ngClass]="{
          'bg-orange-500 text-white': isSalesActive(),
          'text-gray-700 hover:bg-gray-100': !isSalesActive()
        }"
      >
        <i class="pi pi-shopping-bag mr-3"></i>
        Saídas
        <i class="pi" [ngClass]="{'pi-chevron-down': !salesMenuOpen, 'pi-chevron-up': salesMenuOpen}" style="margin-left:auto"></i>
      </a>

      <div *ngIf="salesMenuOpen" class="ml-8 flex flex-col">
        <a
          (click)="goTo('/app/sales')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/sales', true),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/sales', true)
          }"
        >
          Vendas
        </a>

        <a
          (click)="goTo('/app/pre-vendas')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/pre-vendas'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/pre-vendas')
          }"
        >
          Pré Vendas
        </a>
      </div>
    </div>

    <!-- Menu Restaurante com Submenu -->
    <div *ngIf="hasModule('restaurante')">
      <a
        (click)="toggleRestaurantMenu()"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg mb-2"
        [ngClass]="{
          'bg-orange-500 text-white': isRestaurantActive(),
          'text-gray-700 hover:bg-gray-100': !isRestaurantActive()
        }"
      >
        <i class="pi pi-map-marker mr-3"></i>
        Restaurante
        <i class="pi" [ngClass]="{'pi-chevron-down': !restaurantMenuOpen, 'pi-chevron-up': restaurantMenuOpen}" style="margin-left:auto"></i>
      </a>
      <div *ngIf="restaurantMenuOpen" class="ml-8 flex flex-col">
        <a
          (click)="goTo('/app/restaurant/tables')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/restaurant/tables'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/restaurant/tables')
          }"
        >
          Mesas
        </a>
        <a
          (click)="goTo('/app/restaurant/comandas')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/restaurant/comandas'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/restaurant/comandas')
          }"
        >
          Comandas
        </a>
      </div>
    </div>
    
    <!-- Menu Financeiro com Submenu -->
    <div *ngIf="hasModule('financeiro')">
      <a
        (click)="toggleFinanceiroMenu()"
        class="flex items-center px-4 py-3 cursor-pointer rounded-lg mb-2"
        [ngClass]="{
          'bg-orange-500 text-white': isFinanceiroActive(),
          'text-gray-700 hover:bg-gray-100': !isFinanceiroActive()
        }"
      >
        <i class="pi pi-dollar mr-3"></i>
        Financeiro
        <i class="pi" [ngClass]="{'pi-chevron-down': !financeiroMenuOpen, 'pi-chevron-up': financeiroMenuOpen}" style="margin-left:auto"></i>
      </a>
      <div *ngIf="financeiroMenuOpen" class="ml-8 flex flex-col">
        
        <a
          (click)="goTo('/app/financial')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/financial', true),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/financial', true)
          }"
        >
          Receitas
        </a>
        <a
          (click)="goTo('/app/financial/expenses')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/financial/expenses'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/financial/expenses')
          }"
        >
          Despesas
        </a>
        <div class="border-t border-gray-200 my-2"></div>
        <a
          (click)="goTo('/app/financial/expense-types')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/financial/expense-types'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/financial/expense-types')
          }"
        >
          Tipos de Despesa
        </a>
        <a
          (click)="goTo('/app/financial/revenue-types')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/financial/revenue-types'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/financial/revenue-types')
          }"
        >
          Tipos de Receita
        </a>
        <a
          (click)="goTo('/app/financial/bank-accounts')"
          class="flex items-center px-4 py-2 cursor-pointer rounded-lg mb-1"
          [ngClass]="{
            'bg-orange-100 text-orange-700': isActive('/app/financial/bank-accounts'),
            'text-gray-700 hover:bg-gray-100': !isActive('/app/financial/bank-accounts')
          }"
        >
        Tipos de conta
        </a>
      </div>
    </div>

    <a *ngIf="hasModule('relatorios')"
      (click)="goTo('/app/reports')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg mb-2"
      [ngClass]="{
        'bg-orange-500 text-white': isActive('/app/reports'),
        'text-gray-700 hover:bg-gray-100': !isActive('/app/reports')
      }"
    >
      <i class="pi pi-chart-line mr-3"></i>
      Relatórios
    </a>

    <a
      (click)="goTo('/app/companies')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg mb-2"
      [ngClass]="{
        'bg-orange-500 text-white': isActive('/app/companies'),
        'text-gray-700 hover:bg-gray-100': !isActive('/app/companies')
      }"
    >
      <i class="pi pi-building mr-3"></i>
      Empresa
    </a>

    <a
      (click)="goTo('/app/modules')"
      class="flex items-center px-4 py-3 cursor-pointer rounded-lg mb-2"
      [ngClass]="{
        'bg-orange-500 text-white': isActive('/app/modules'),
        'text-gray-700 hover:bg-gray-100': !isActive('/app/modules')
      }"
    >
      <i class="pi pi-th-large mr-3"></i>
      Módulos
    </a>
  </nav>
</div>